import React from 'react'
import PropTypes from 'prop-types'
import {useMultiStyleConfig, Box, useStyleConfig, Flex} from '@chakra-ui/react'
import OmnibusPrice from '../omnibus-price'
import DisplayPrice from '..'
import useProductData from '../../../hooks/use-product-data'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import ItemPriceCustom from '../../item-variant/item-price-custom'
import {remCalc} from '../../../theme/_utils'

const OmnibusModalPrice = ({
    product,
    quantity = 1,
    addToCartView = true,
    modalPriceRecommended = false,
    isMinicart = false,
}) => {
    const {currency} = useCurrency()
    const pricingStyles = useMultiStyleConfig('Modal')
    const stylesItemPrice = useStyleConfig('MiniCartPopover')

    const {priceData} = useProductData(product)

    return (
        <Flex
            flexDir="column"
            gap={{base: remCalc(4), lg: remCalc(12)}}
            alignItems={{base: 'start', lg: 'end'}}
        >
            {addToCartView ? (
                <DisplayPrice
                    {...pricingStyles.productPricing}
                    priceData={priceData}
                    quantity={quantity}
                    currency={currency}
                    modalPrice={true}
                    modalPriceRecommended={modalPriceRecommended}
                    isMinicart={isMinicart}
                />
            ) : (
                <>
                    <ItemPriceCustom
                        currency={currency}
                        basePrice={product?.basePrice}
                        styles={stylesItemPrice}
                        showOmnibusLabel={!priceData.showOmnibusPriceDiscount}
                    />
                </>
            )}
            {priceData.showOmnibusPriceDiscount && (
                <Box style={addToCartView ? {...pricingStyles.productOmnibusWrapper} : {}}>
                    <OmnibusPrice
                        priceData={priceData}
                        currency={currency}
                        omnibusExpandedView={false}
                        variant="recommended"
                    />
                </Box>
            )}
        </Flex>
    )
}

OmnibusModalPrice.propTypes = {
    product: PropTypes.object,
    products: PropTypes.object,
    quantity: PropTypes.number,
    addToCartView: PropTypes.bool,
    modalPriceRecommended: PropTypes.bool,
    isMinicart: PropTypes.bool,
}

export default OmnibusModalPrice
